import sectionKonfortifyFbCss from '../css-snippets/section-konfortify-fb';

const reactionIcons = [
  `<svg fill=none height=18 viewBox="0 0 16 16"width=18 xmlns=http://www.w3.org/2000/svg><defs><linearGradient gradientUnits=userSpaceOnUse id=gradient-column_YpyKXV0 x1=8 x2=8 y2=16><stop stop-color=#18AFFF></stop><stop stop-color=#0062DF offset=1></stop></linearGradient></defs><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Z"fill=url(#gradient-column_YpyKXV0)></path><path d="M12.162 7.338c.176.123.338.245.338.674 0 .43-.229.604-.474.725.1.163.132.36.089.546-.077.344-.392.611-.672.69.121.194.159.385.015.62-.185.295-.346.407-1.058.407H7.5c-.988 0-1.5-.546-1.5-1V7.665c0-1.23 1.467-2.275 1.467-3.13L7.361 3.47c-.005-.065.008-.224.058-.27.08-.079.301-.2.635-.2.218 0 .363.041.534.123.581.277.732.978.732 1.542 0 .271-.414 1.083-.47 1.364 0 0 .867-.192 1.879-.199 1.061-.006 1.749.19 1.749.842 0 .261-.219.523-.316.666ZM3.6 7h.8a.6.6 0 0 1 .6.6v3.8a.6.6 0 0 1-.6.6h-.8a.6.6 0 0 1-.6-.6V7.6a.6.6 0 0 1 .6-.6Z"fill=#fff></path></svg>`,
  `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#f02849"/><path fill="#fff" d="M8 12.5 3.7 8.6A2.7 2.7 0 0 1 7.5 4.8L8 5.4l.5-.6a2.7 2.7 0 0 1 3.8 3.8L8 12.5Z"/></svg>`,
  `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16 16"
    >
      <linearGradient
        id="gradient-column_bAXfdp2a"
        x1="-2.313"
        x2="-2.313"
        y1="19.862"
        y2="20.738"
        gradientTransform="matrix(16 0 0 -16 45 333)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#f28a2d"></stop>
        <stop offset="1" stop-color="#fde86f"></stop>
      </linearGradient>
      <path
        fill="url(#gradient-column_bAXfdp2a)"
        fill-rule="evenodd"
        d="M16 8c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2b"
        cx="-2.313"
        cy="20.313"
        r=".5"
        gradientTransform="matrix(16 0 0 -16 45 333)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#f28a2d" stop-opacity="0"></stop>
        <stop offset="1" stop-color="#f08423" stop-opacity=".34"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2b)"
        fill-rule="evenodd"
        d="M16 8c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2c"
        cx="-2.644"
        cy="20.358"
        r=".101"
        gradientTransform="matrix(14.5998 6.5456 5.063 -11.2928 -62.74 255.526)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#f28a2d" stop-opacity=".5"></stop>
        <stop offset="1" stop-color="#f28a2d" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2c)"
        fill-rule="evenodd"
        d="M16 8c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2d"
        cx="-2.227"
        cy="19.541"
        r=".283"
        gradientTransform="matrix(12.5663 -9.904 -3.6032 -4.5717 110.263 79.053)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#f28a2d" stop-opacity=".5"></stop>
        <stop offset="1" stop-color="#f28a2d" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2d)"
        fill-rule="evenodd"
        d="M16 8c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2e"
        cx="-2.531"
        cy="19.776"
        r=".107"
        gradientTransform="matrix(15.7394 -2.8762 -.572 -3.1299 56.242 56.647)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#d45f00" stop-opacity=".15"></stop>
        <stop offset="1" stop-color="#f28a2d" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2e)"
        fill-rule="evenodd"
        d="M16 8c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2f"
        cx="-2.098"
        cy="20.131"
        r=".106"
        gradientTransform="matrix(15.6768 3.1995 .6363 -3.1176 30.972 71.62)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#d45f00" stop-opacity=".15"></stop>
        <stop offset="1" stop-color="#d45f00" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2f)"
        fill-rule="evenodd"
        d="M16 8c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"
        clip-rule="evenodd"
      ></path>
      <linearGradient
        id="gradient-column_bAXfdp2g"
        x1="-1.619"
        x2="-1.619"
        y1="18.2"
        y2="16.681"
        gradientTransform="matrix(3.4035 0 0 -.9374 13.51 22.37)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#482314"></stop>
        <stop offset="1" stop-color="#9a4111"></stop>
      </linearGradient>
      <path
        fill="url(#gradient-column_bAXfdp2g)"
        fill-rule="evenodd"
        d="M9.7 5.9c-.1-.3-3.3-.3-3.4 0-.1.3.6.7 1.7.7s1.8-.4 1.7-.7z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2h"
        cx="-3.9"
        cy="18.924"
        r=".872"
        gradientTransform="matrix(0 -2.1326 -2.1327 0 45.352 -4.046)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#3b446b"></stop>
        <stop offset=".688" stop-color="#202340"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2h)"
        fill-rule="evenodd"
        d="M6 4.1c0 .7-.4.9-1 1-.6.1-1.1-.2-1.1-1 0-.6.3-1.4 1.1-1.4.7 0 1 .8 1 1.4z"
        clip-rule="evenodd"
      ></path>
      <path
        fill="#4e506a"
        fill-rule="evenodd"
        d="M4.9 3.1c.1.1.1.4-.1.5-.1.1-.3.2-.4 0s-.1-.3 0-.5c.2-.1.4-.1.5 0z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2i"
        cx="-3.914"
        cy="18.924"
        r=".872"
        gradientTransform="matrix(0 -2.1326 -2.1327 0 51.366 -4.077)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#3b446b"></stop>
        <stop offset=".688" stop-color="#202340"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2i)"
        fill-rule="evenodd"
        d="M10 4.1c0 .7.4.9 1.1 1 .6.1 1.1-.2 1.1-1 0-.6-.3-1.4-1.1-1.4S10 3.5 10 4.1z"
        clip-rule="evenodd"
      ></path>
      <path
        fill="#4e506a"
        fill-rule="evenodd"
        d="M11 3.1c.1.1 0 .3-.1.5-.1.1-.3.1-.4 0s0-.3.1-.5c.2-.2.3-.2.4 0z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2j"
        cx="-5.202"
        cy="20.231"
        r=".298"
        gradientTransform="matrix(-.339 -1.3177 -6.1081 1.5713 126.811 -36.933)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#e38200"></stop>
        <stop offset="1" stop-color="#cd6700"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2j)"
        fill-rule="evenodd"
        d="M3.4 2.1c-.2.2 0 .5.3.4.6-.3 1.8-.6 2.8-.5.3 0 .4 0 .3-.4 0-.3-.4-.5-1.2-.4-1.2.1-2 .7-2.2.9z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2k"
        cx="-4.247"
        cy="20.267"
        r=".314"
        gradientTransform="matrix(.2577 -1.3359 -7.9278 -1.5293 172.702 26.852)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#e38200"></stop>
        <stop offset="1" stop-color="#cd6700"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2k)"
        fill-rule="evenodd"
        d="M10.4 1.2c-.8-.1-1.2.1-1.2.4-.1.4 0 .4.3.4 1.1-.1 2.3.2 2.8.5.4.2.5-.2.3-.4s-1-.8-2.2-.9z"
        clip-rule="evenodd"
      ></path>
      <linearGradient
        id="gradient-column_bAXfdp2l"
        x1="-2.17"
        x2="-2.407"
        y1="20.358"
        y2="19.647"
        gradientTransform="matrix(9.7496 0 0 -9.079 27.91 194.578)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#f34462"></stop>
        <stop offset="1" stop-color="#cc0820"></stop>
      </linearGradient>
      <path
        fill="url(#gradient-column_bAXfdp2l)"
        fill-rule="evenodd"
        d="M9.7 8.5c-2.1-.6-2.8.8-2.8.8S7.1 7.7 5 7c-2-.6-3.2 1.3-3.3 2.4-.2 2.5 2 5.3 2.8 6.3.1.3.4.3.7.3 1.2-.3 4.6-1.4 5.9-3.6.5-1.1.6-3.3-1.4-3.9z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2m"
        cx="-1.839"
        cy="20.363"
        r=".29"
        gradientTransform="matrix(8.51 3.1636 3.1637 -8.51 -39.932 190.042)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#ff7091" stop-opacity=".7"></stop>
        <stop offset="1" stop-color="#fe6d8e" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2m)"
        fill-rule="evenodd"
        d="M9.7 8.5c-2.1-.6-2.8.8-2.8.8S7.1 7.7 5 7c-2-.6-3.2 1.3-3.3 2.4-.2 2.5 2 5.3 2.8 6.3.1.3.4.3.7.3 1.2-.3 4.6-1.4 5.9-3.6.5-1.1.6-3.3-1.4-3.9z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2n"
        cx="-2.308"
        cy="20.509"
        r=".29"
        gradientTransform="matrix(8.51 3.1636 3.1637 -8.51 -40.975 191.442)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#ff7091" stop-opacity=".7"></stop>
        <stop offset="1" stop-color="#fe6d8e" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2n)"
        fill-rule="evenodd"
        d="M9.7 8.5c-2.1-.6-2.8.8-2.8.8S7.1 7.7 5 7c-2-.6-3.2 1.3-3.3 2.4-.2 2.5 2 5.3 2.8 6.3.1.3.4.3.7.3 1.2-.3 4.6-1.4 5.9-3.6.5-1.1.6-3.3-1.4-3.9z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2o"
        cx="-2.505"
        cy="20.75"
        r=".249"
        gradientTransform="matrix(-1.8271 8.8932 12.246 2.5158 -254.697 -18.163)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#9c0600"></stop>
        <stop offset="1" stop-color="#9c0600" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2o)"
        fill-rule="evenodd"
        d="M9.7 8.5c-2.1-.6-2.8.8-2.8.8S7.1 7.7 5 7c-2-.6-3.2 1.3-3.3 2.4-.2 2.5 2 5.3 2.8 6.3.1.3.4.3.7.3 1.2-.3 4.6-1.4 5.9-3.6.5-1.1.6-3.3-1.4-3.9z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2p"
        cx="-1.547"
        cy="20.349"
        r=".15"
        gradientTransform="matrix(7.812 4.6261 5.8059 -9.8043 -94.645 218.657)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#9c0600" stop-opacity=".5"></stop>
        <stop offset="1" stop-color="#9c0600" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2p)"
        fill-rule="evenodd"
        d="M9.7 8.5c-2.1-.6-2.8.8-2.8.8S7.1 7.7 5 7c-2-.6-3.2 1.3-3.3 2.4-.2 2.5 2 5.3 2.8 6.3.1.3.4.3.7.3 1.2-.3 4.6-1.4 5.9-3.6.5-1.1.6-3.3-1.4-3.9z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2q"
        cx="-2.763"
        cy="20.429"
        r=".13"
        gradientTransform="matrix(8.5228 -3.1289 -4.0321 -10.983 107.977 224.84)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#9c0600" stop-opacity=".5"></stop>
        <stop offset="1" stop-color="#9c0600" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2q)"
        fill-rule="evenodd"
        d="M9.7 8.5c-2.1-.6-2.8.8-2.8.8S7.1 7.7 5 7c-2-.6-3.2 1.3-3.3 2.4-.2 2.5 2 5.3 2.8 6.3.1.3.4.3.7.3 1.2-.3 4.6-1.4 5.9-3.6.5-1.1.6-3.3-1.4-3.9z"
        clip-rule="evenodd"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2r"
        cx="-1.795"
        cy="20.148"
        r=".175"
        gradientTransform="matrix(7.5205 5.0863 5.5088 -8.1451 -88.557 187.152)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#9c0600" stop-opacity=".999"></stop>
        <stop offset="1" stop-color="#9c0600" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2r)"
        fill-rule="evenodd"
        d="M9.7 8.5c-2.1-.6-2.8.8-2.8.8S7.1 7.7 5 7c-2-.6-3.2 1.3-3.3 2.4-.2 2.5 2 5.3 2.8 6.3.1.3.4.3.7.3 1.2-.3 4.6-1.4 5.9-3.6.5-1.1.6-3.3-1.4-3.9z"
        clip-rule="evenodd"
      ></path>
      <defs>
        <filter
          id="gradient-column_bAXfdp2s"
          width="6.9"
          height="5.4"
          x="-.2"
          y="7.2"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"></feColorMatrix>
        </filter>
      </defs>
      <mask
        id="gradient-column_bAXfdp2u"
        width="6.9"
        height="5.4"
        x="-.2"
        y="7.2"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          fill-rule="evenodd"
          d="M16 8c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"
          clip-rule="evenodd"
          filter="url(#gradient-column_bAXfdp2s)"
        ></path>
      </mask>
      <radialGradient
        id="gradient-column_bAXfdp2t"
        cx="-2.204"
        cy="20.844"
        r="1.226"
        gradientTransform="matrix(4.3582 3.2271 3.227 -4.3582 -57.739 105.424)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#eda83a"></stop>
        <stop offset="1" stop-color="#ffdc5e"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2t)"
        fill-rule="evenodd"
        d="M1.3 7.7c-.5-.5-1.4-.8-1.5.4-.1.9.3 2.5 1.4 3.4 2.8 2.2 5.3 1 5.4-.6.1-1.2-1.4-1.1-1.8-1.1v-.1c.1-.1.3-.2.4-.3.4-.3.2-.8-.3-.7-.1 0-1.3.4-2.1.1-.8-.3-.9-.6-1.5-1.1z"
        clip-rule="evenodd"
        mask="url(#gradient-column_bAXfdp2u)"
      ></path>
      <radialGradient
        id="gradient-column_bAXfdp2v"
        cx="15.654"
        cy="7.737"
        r="8.846"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#eda83a"></stop>
        <stop offset="1" stop-color="#ffdc5e"></stop>
      </radialGradient>
      <path
        fill="url(#gradient-column_bAXfdp2v)"
        d="M14.3 7.8c.3-.6.8-.4 1.1-.3.4.1.7.4.7 1 0 1.5-.2 2.9-1.5 4.3-2.3 2.6-6.2 2.2-6.6.6-.3-1.2 1.1-1.4 1.6-1.4v-.1c-.2-.1-.3-.2-.5-.3-.4-.3-.3-.9.2-.8.6.1 1.4.3 2 .2 1.9-.2 2.2-1.7 3-3.2z"
      ></path>
    </svg>`,
];

const actionItems = [
  {
    label: 'Like',
    icon: `<svg xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
    >
      <path
        d="m476.229 223.454c-13.977-16.845-35.861-27.309-57.113-27.309h-56.219c12.652-20.162 22.174-40.451 27.977-59.771 8.855-29.482 8.545-55.182-.897-74.322-10.635-21.558-32.187-33.431-60.683-33.431-6.481 0-12.322 3.91-14.792 9.902-22.188 53.817-80.062 131.167-134.589 182.122-5.564-19.327-23.395-33.511-44.488-33.511h-68.5c-25.529 0-46.299 20.77-46.299 46.298v203.646c0 25.529 20.77 46.299 46.299 46.299h68.5c15.617 0 29.443-7.781 37.833-19.661 12.692 12.211 29.518 19.661 47.955 19.661h172.481c19.068 0 36.048-8.119 49.106-23.479 10.764-12.663 18.409-29.77 22.107-49.471l25.423-135.427c3.411-18.17-1.597-36.476-14.101-51.546zm-326.506 213.625c0 7.884-6.414 14.299-14.298 14.299h-68.5c-7.884 0-14.299-6.415-14.299-14.299v-203.646c0-7.884 6.415-14.298 14.299-14.298h68.5c7.884 0 14.298 6.414 14.298 14.298zm309.156-167.983-25.422 135.428c-4.252 22.651-16.931 46.854-39.764 46.854h-172.481c-21.774 0-39.488-19.694-39.488-43.902v-145.741c60.311-50.068 127.854-136.057 157.672-200.327 15.909 2.692 20.279 11.549 21.884 14.801 10.385 21.051 1.766 69.522-41.697 126.199-3.707 4.833-4.347 11.353-1.652 16.815s8.257 8.921 14.349 8.921h86.837c11.8 0 24.552 6.179 32.486 15.742 4.467 5.386 9.357 14.13 7.276 25.21z"
      ></path>
    </svg>
    `,
  },
  {
    label: 'Comment',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true"><path d="M411.289 14.988h-310.578c-46.239 0-83.856 37.618-83.856 83.856v203.555c0 46.239 37.618 83.857 83.856 83.857h36.607v64.208c0 17.804 9.469 33.261 25.33 41.348 6.822 3.479 14.052 5.2 21.225 5.2 9.503 0 18.906-3.022 27.118-8.98l140.274-101.776h60.024c46.239 0 83.856-37.618 83.856-83.857v-203.555c.001-46.239-37.617-83.856-83.856-83.856zm51.857 287.411c0 28.594-23.263 51.857-51.856 51.857h-65.217c-3.375 0-6.664 1.067-9.396 3.05l-144.479 104.825c-4.608 3.345-9.94 3.761-15.013 1.174-5.073-2.586-7.866-7.147-7.866-12.841v-80.208c0-8.836-7.164-16-16-16h-52.607c-28.594 0-51.856-23.263-51.856-51.857v-203.555c0-28.594 23.263-51.856 51.856-51.856h310.578c28.594 0 51.856 23.263 51.856 51.856z"/></svg>`,
  },
  {
    label: 'Share',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true"><path d="m491.184 177.664-174.226-143.783c-4.778-3.943-11.402-4.773-17.005-2.133-5.603 2.641-9.179 8.279-9.179 14.473v58.521c-71.923 3.86-138.994 33.709-190.316 85.031-55.108 55.109-85.458 128.38-85.458 206.315 0 24.95 3.165 49.754 9.407 73.723 1.835 7.048 8.2 11.968 15.483 11.968 7.284 0 13.648-4.919 15.483-11.968 28.413-109.11 123.908-186.805 235.4-193.627v57.604c0 6.194 3.576 11.833 9.179 14.473s12.228 1.811 17.005-2.133l174.226-143.783c3.683-3.04 5.816-7.565 5.816-12.34s-2.132-9.302-5.815-12.341zm-168.41 122.174v-40.143c0-8.836-7.164-16-16-16-111.16 0-210.621 62.81-259.702 158.554-.048-2.051-.072-4.106-.072-6.161 0-143.24 116.534-259.774 259.774-259.774 8.836 0 16-7.164 16-16v-40.143l133.088 109.834z"/></svg>`,
  },
];

const posts = [
  {
    author: 'Pamela N.',
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82dd760f76e1c34265aea0.webp?w=500',
    createdAt: '6h ago',
    text:
      'Very light and comfortable to wear. I often suffer from plantar pain, but with these shoes I finally feel comfortable all day long.',
    image: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82dd79c4c504b46c91decb.webp?w=1000',
  },
  {
    author: 'Michelle O.',
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82ddb2014f41bf57acc9c6.webp?w=500',
    createdAt: '13h ago',
    text: "I was looking for shoes that alleviate heel pain and I'm bluffed. You can feel the difference right away.",
    image: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82ddb8f7b51105ff817cca.avif?w=1000',
  },
  {
    author: 'Lisa D.',
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82ddedace73980650447a0.webp?w=500',
    createdAt: '8h ago',
    text: "Fast delivery and compliant product. Comfortable from the first use. I'm delighted with my purchase!",
    image: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82ddf2e0f7baa6e0782eda.avif?w=1000',
  },
  {
    author: 'Angela B.',
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82de1ce45d2e04bd214bd5.webp?w=500',
    createdAt: '1d ago',
    text:
      "Very comfortable shoes, easy to put on. Even after hours of walking, I don't feel any discomfort. That's rare!",
    image: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82de20bba559a176abaa1b.avif?w=1000',
  },
  {
    author: 'Karen S.',
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82de4474567674c369b517.jpg?w=500',
    createdAt: '1d ago',
    text:
      "Top customer service and fast delivery. The shoes are very pretty and above all ultra comfortable, I can't do without them.",
    image: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82de494cb104d1a5eb4e4d.jpg?w=1000',
  },
  {
    author: 'Susan',
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82de7f0f975cb1ddea6bbe.webp?w=500',
    createdAt: '3d ago',
    text:
      'The package arrived quickly and the shoes are even better than I expected. I will definitely recommend another pair.',
    image: 'https://cdn.skyfastimg.com/images/2026/08/17/image-6a82de8b13f6a72e7602db2c.webp?w=1000',
  },
];

const renderPost = ({ author, avatar, createdAt, text, image }) => `
  <div class="wrap-item swiper-slide">
    <div class="author">
      <div data-attribute="author-avatar" class="author-avatar"><img src="${avatar}" alt=""></div>
      <div data-attribute="text-user" class="text-user">
        <div data-attribute="user-name" class="author-name">${author}</div>
        <div data-attribute="created-at" class="created-at">${createdAt}</div>
      </div>
    </div>
    <div data-attribute="post-content" class="post-content">
      <div data-attribute="post-text" class="post-text">${text}</div>
      <div data-attribute="post-img" class="wrap-img"><img src="${image}" alt=""></div>
    </div>
    <div class="wrap-state">
      <div class="wrap-reactions">
        <div class="wrap-icon">${reactionIcons.map(icon => `<div class="icon-reaction">${icon}</div>`).join('')}</div>
        <div data-attribute="reaction-count" class="reaction-count">67</div>
      </div>
      <div class="comment"><div data-attribute="comment-count" class="comment-count">2</div><div class="text-comment">Comment</div></div>
    </div>
    <div class="wrap-actions-disable">
      ${actionItems
        .map(
          ({ label, icon }) =>
            `<div class="item-action"><div class="icon-action">${icon}</div><div class="text-action">${label}</div></div>`,
        )
        .join('')}
    </div>
  </div>`;

const html = `
<style>${sectionKonfortifyFbCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#ffffff"
  data-top-padding="true" data-bottom-padding="true"
  style="background-color: #ffffff; color: #000000; --text-color: #000000;" data-text-color="#000000">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div data-attribute="container" class="container">
      <div class="wrap-card">
        <div data-attribute="title-post" data-show="false" class="title-post">
          <h2 style="text-align:center;"><strong>Title</strong></h2>
          <p style="text-align:center;">Description</p>
        </div>
        <div class="wrap-slider-post-items">
          <div class="swiper">
            <div data-attribute="list-post" data-col-per-view="3" class="list-post swiper-wrapper">${posts
              .map(renderPost)
              .join('')}</div>
            <div class="swiper-pagination"></div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div>
  </div>
</div>`;

export default html;
